/**
 * KpiTile — the canonical KPI tile used across the feature pages.
 *
 * Previously this exact component was redeclared (as a local `Tile`) on
 * NextBestAction, ExploitationRace, AIVulnDiscovery, TargetState and
 * PurpleRange. One shared version keeps padding, label casing, value size
 * and hint styling identical everywhere.
 *
 * Drop these into a `grid grid-cols-2 md:grid-cols-4 gap-3` so they collapse
 * to two-up on mobile.
 */
import { clsx } from 'clsx'

export default function KpiTile({
  label, value, hint, tone, icon: Icon, className,
}: {
  label: string
  value: React.ReactNode
  hint?: string
  /** Text-colour util for the value (e.g. 'text-rose-light'). */
  tone?: string
  /** Optional leading icon next to the label. */
  icon?: React.ElementType
  className?: string
}) {
  return (
    <div className={clsx('card p-3', className)}>
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-text-muted">
        {Icon && <Icon size={11} />} {label}
      </div>
      <div className={clsx('text-2xl font-bold mt-1', tone || 'text-text-primary')}>{value}</div>
      {hint && <div className="text-[10px] text-text-muted mt-0.5">{hint}</div>}
    </div>
  )
}
